var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { WithModal } from '@amzn/atoz-web/Modal';
import { Col } from '@amzn/atoz-web/Col';
export var ModalWrapper = function (_a) {
    var children = _a.children, _b = _a.isList, isList = _b === void 0 ? false : _b, withModalProps = __rest(_a, ["children", "isList"]);
    return (React.createElement(WithModal, __assign({}, withModalProps), function (_a) {
        var close = _a.close, open = _a.open, isOpen = _a.isOpen;
        return (React.createElement(React.Fragment, null, isList ? (React.createElement(Col, { role: "list", gridGap: "S300" }, children({
            openModal: open,
            closeModal: close,
            modalIsOpen: isOpen
        }))) : (children({
            openModal: open,
            closeModal: close,
            modalIsOpen: isOpen
        }))));
    }));
};
